<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="row" style="background: #fff;">
        <div class="col-12 mb-4">
            <v-card    style="padding: 10px;margin-bottom: 5px" v-if="!marchand">
                <v-alert
                        dense
                        outlined
                        type="error">
                    {{$t('documents.document_info')}}
                </v-alert>
            </v-card>
            <div v-else-if="document==null">
                <v-card-text>

                    <v-form  ref="form" v-model="valid" :lazy-validation="lazy"  enctype="multipart/form-data">
                        <v-container style="margin-top: 2%">
                            <v-alert  v-if="errors"  dense outlined :type="(errors.update_error)?'error':'success'">{{$t(errors.message)}}</v-alert>
                            <v-text-field  v-if="submitting" color="primary" loading disabled></v-text-field>

                            <v-row >
                                <v-col cols="12" sm="6" >
                                    <h6>{{$t('documents.document_passport_label')}}</h6>
                                    <v-text-field :rules="numRules" required v-model="editedItem._numCard" :label="$t('documents.document_passport_label')" :placeholder="$t('documents.document_passport_label')" type="text" single-line solo></v-text-field>
                                </v-col>
                                <v-col  cols="12" sm="6" >
                                    <h6>{{$t('documents.document_passport_file')}}</h6>

                                    <v-file-input
                                            v-model="editedItem._fileCar"
                                            counter
                                            id="card" :rules="fileRules"   prepend-icon="mdi-camera"  accept="image/*,application/pdf"
                                            :show-size="1000"
                                            solo>
                                        <template v-slot:selection="{ index}">
                                            <v-chip
                                                    v-if="index < 2"
                                                    label
                                                    small
                                            >
                                                Cliqué pour choisir votre fichier
                                            </v-chip>

                                        </template>
                                    </v-file-input>

                                </v-col>

                                <v-col style:="" cols="12" sm="6" >
                                    <h6>{{$t('documents.document_rccm_label')}}</h6>

                                    <v-text-field  :rules="numrRules" required v-model="editedItem._numRCCM" :label="$t('documents.document_rccm_label')" :placeholder="$t('documents.document_rccm_label')" type="text" single-line solo></v-text-field>
                                </v-col>
                                <v-col  cols="12" sm="6">
                                    <h6>{{$t('documents.document_rccm_file')}} </h6>

                                    <v-file-input
                                            v-model="editedItem._fileRCC" :rules="editedIndex === -1?filerRules:''"
                                            counter
                                            id="card"
                                            prepend-icon="mdi-paperclip"
                                            accept="application/pdf"
                                            :show-size="1000"
                                            solo>
                                        <template v-slot:selection="{ index}">
                                            <v-chip
                                                    v-if="index < 2"
                                                    label
                                                    small
                                            >
                                                Cliqué pour choisir votre fichier (pdf)
                                            </v-chip>

                                        </template>
                                    </v-file-input>

                                </v-col>
                                <v-col cols="12" sm="6" >
                                    <h6>{{$t('documents.document_ifu_label')}}</h6>

                                    <v-text-field :rules="numiRules" required v-model="editedItem._numIFU" :label="$t('documents.document_ifu_label')" :placeholder="$t('documents.document_ifu_label')" type="text" single-line solo></v-text-field>
                                </v-col>
                                <v-col  cols="12" sm="6" >
                                    <h6>{{$t('documents.document_ifu_file')}}</h6>
                                    <v-file-input
                                            v-model="editedItem._fileIFU"  :rules="editedIndex === -1?fileiRules:''"                                             counter
                                            id="card"
                                            prepend-icon="mdi-paperclip"
                                            accept="application/pdf"
                                            :show-size="1000"
                                            solo>
                                        <template v-slot:selection="{ index}">
                                            <v-chip
                                                    v-if="index < 2"
                                                    label
                                                    small
                                            >
                                                Cliqué pour choisir votre fichier (pdf)
                                            </v-chip>

                                        </template>
                                    </v-file-input>

                                </v-col>
                            </v-row>
                        </v-container>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="float-right" :disabled="!valid || mis"   @click.prevent="save" color="primary" >{{$t('save')}}</v-btn>
                </v-card-actions>
            </div>
            <div v-else>
                <div v-if="document._valide===false">
                    <v-card-text>
                        <v-form  ref="form" v-model="valid" :lazy-validation="lazy"  enctype="multipart/form-data">
                            <v-container style="margin-top: 2%">
                                <v-alert  v-if="errors"  dense outlined :type="(errors.update_error)?'error':'success'">{{$t(errors.message)}}</v-alert>
                                <v-text-field  v-if="submitting" color="primary" loading disabled></v-text-field>

                                <v-row >
                                    <v-col cols="12" sm="6" >
                                        <h6>{{$t('documents.document_passport_label')}}</h6>
                                        <v-text-field :rules="numRules" required v-model="editedItem._numCard" :label="$t('documents.document_passport_label')" :placeholder="$t('documents.document_passport_label')" type="text" single-line solo></v-text-field>
                                    </v-col>
                                    <v-col  cols="12" sm="6" >
                                        <h6>{{$t('documents.document_passport_file')}}</h6>
                                        <div v-if="editedItem._fileCard">
                                            <v-file-input
                                                    v-model="editedItem._fileCar"  placeholder="Pièce d'identité"  :rules="fileRules"
                                                    prepend-icon="mdi-camera"
                                                    accept="image/*,application/pdf"
                                                    :show-size="1000"
                                                    solo>
                                                <template v-slot:selection="{ index}">
                                                    <v-chip
                                                            v-if="index < 2"
                                                            label
                                                            small
                                                    >
                                                        Cliqué pour choisir votre fichier
                                                    </v-chip>

                                                </template>
                                            </v-file-input>

                                        </div>
                                        <div v-else>
                                            <v-file-input
                                                    v-model="editedItem._fileCar"  placeholder="Null"  :rules="fileRules"
                                                    prepend-icon="mdi-camera"
                                                    accept="image/*,application/pdf"
                                                    :show-size="1000"
                                                    solo>
                                                <template v-slot:selection="{ index}">
                                                    <v-chip
                                                            v-if="index < 2"
                                                            label
                                                            small
                                                    >
                                                        Cliqué pour choisir votre fichier
                                                    </v-chip>

                                                </template>
                                            </v-file-input>

                                        </div>
                                    </v-col>

                                    <v-col style:="" cols="12" sm="6" >
                                        <h6>{{$t('documents.document_rccm_label')}}</h6>

                                        <v-text-field  :rules="numrRules" required v-model="editedItem._numRCCM" :label="$t('documents.document_rccm_label')" :placeholder="$t('documents.document_rccm_label')" type="text" single-line solo></v-text-field>
                                    </v-col>
                                    <v-col  cols="12" sm="6">
                                        <h6>{{$t('documents.document_rccm_file')}} </h6>
                                        <div v-if="editedItem._fileRCCM">
                                            <v-file-input
                                                    v-model="editedItem._fileRCC" placeholder="Document RCCM" :rules="editedIndex === -1?filerRules:''"
                                                    id="card"        prepend-icon="mdi-paperclip"
                                                    accept="application/pdf"
                                                    :show-size="1000"
                                                    solo>
                                                <template v-slot:selection="{ index}">
                                                    <v-chip
                                                            v-if="index < 2"
                                                            label
                                                            small
                                                    >
                                                        Cliqué pour choisir votre fichier (pdf)
                                                    </v-chip>

                                                </template>
                                            </v-file-input>

                                        </div>
                                        <div v-else>
                                            <v-file-input
                                                    v-model="editedItem._fileRCC" placeholder="Null" :rules="editedIndex === -1?filerRules:''"                                                     counter
                                                    id="card"
                                                    prepend-icon="mdi-paperclip"
                                                    accept="application/pdf"
                                                    :show-size="1000"
                                                    solo>
                                                <template v-slot:selection="{ index}">
                                                    <v-chip
                                                            v-if="index < 2"
                                                            label
                                                            small
                                                    >
                                                        Cliqué pour choisir votre fichier (pdf)
                                                    </v-chip>

                                                </template>
                                            </v-file-input>

                                        </div>
                                    </v-col>
                                    <v-col cols="12" sm="6" >
                                        <h6>{{$t('documents.document_ifu_label')}}</h6>

                                        <v-text-field :rules="numiRules" required v-model="editedItem._numIFU" :label="$t('documents.document_ifu_label')" :placeholder="$t('documents.document_ifu_label')" type="text" single-line solo></v-text-field>
                                    </v-col>
                                    <v-col  cols="12" sm="6" >
                                        <h6>{{$t('documents.document_ifu_file')}}</h6>
                                        <div v-if="editedItem._fileIFU">
                                            <v-file-input
                                                    v-model="editedItem._fileIF"  placeholder="Document IFU" :rules="editedIndex === -1?fileiRules:''"
                                                    counter
                                                    id="card"
                                                    prepend-icon="mdi-paperclip"
                                                    accept="application/pdf"
                                                    :show-size="1000"
                                                    solo>
                                                <template v-slot:selection="{ index}">
                                                    <v-chip
                                                            v-if="index < 2"
                                                            label
                                                            small
                                                    >
                                                        Cliqué pour choisir votre fichier (pdf)
                                                    </v-chip>

                                                </template>
                                            </v-file-input>

                                        </div>
                                        <div v-else>
                                            <v-file-input
                                                    v-model="editedItem._fileIF"  placeholder="Null" :rules="editedIndex === -1?fileiRules:''"                                                    counter
                                                    id="card"
                                                    prepend-icon="mdi-paperclip"
                                                    accept="application/pdf"
                                                    :show-size="1000"
                                                    solo>
                                                <template v-slot:selection="{ index}">
                                                    <v-chip
                                                            v-if="index < 2"
                                                            label
                                                            small
                                                    >
                                                        Cliqué pour choisir votre fichier (pdf)
                                                    </v-chip>

                                                </template>
                                            </v-file-input>

                                        </div>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn  class="float-right" :disabled="!editedItem._numCard || mis || !editedItem._fileCard || !editedItem._numRCCM || !editedItem._fileRCCM || !editedItem._numIFU || !editedItem._fileIFU"   @click.prevent="save" color="primary" >{{$t('update')}}</v-btn>
                    </v-card-actions>
                </div>
                <div v-else>
                    <div class="row">
                        <div class="col-6">
                            <v-col cols="12" >
                                <label style="font-weight: 600;">{{$t('documents.document_passport_label')}}</label><br>


                                <v-text-field
                                        :value="document._numCard"
                                        :label="$t('documents.document_passport_label')"
                                        solo
                                        disabled
                                ></v-text-field>
                            </v-col>

                        </div>

                        <div class="col-6">
                            <v-col cols="12" >
                                <label style="font-weight: 600;">{{$t('documents.document_passport_text')}}</label><br>

                                <div v-if="document._fileCard">
                                    <a :href="base+document._fileCard" target="_blank">
                                        <v-text-field
                                                value="Pièce d'identité"
                                                :label="$t('documents.document_passport_file')"
                                                solo
                                                disabled
                                        ></v-text-field>
                                    </a>
                                </div>
                                <div v-else>
                                    <v-text-field
                                            value="Null"
                                            :label="$t('documents.document_passport_file')"
                                            solo
                                            disabled
                                    ></v-text-field>
                                </div>

                            </v-col>

                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <v-col cols="12" >
                                <label style="font-weight: 600;">{{$t('documents.document_rccm_label')}}</label><br>


                                <v-text-field
                                        :value="document._numRCCM"
                                        :label="$t('documents.document_rccm_label')"
                                        solo
                                        disabled
                                ></v-text-field>
                            </v-col>

                        </div>
                        <div class="col-6">
                            <v-col cols="12" >
                                <label style="font-weight: 600;">{{$t('documents.document_rccm_text')}}</label><br>
                                <div v-if="document._fileRCCM">
                                    <a :href="base+document._fileRCCM" target="_blank">

                                        <v-text-field
                                                value="Document RCCM"
                                                :label="$t('documents.document_rccm_file')"
                                                solo
                                                disabled
                                        ></v-text-field>
                                    </a>
                                </div>
                                <div v-else>
                                    <v-text-field
                                            value="Null"
                                            :label="$t('documents.document_rccm_file')"
                                            solo
                                            disabled
                                    ></v-text-field>
                                </div>


                            </v-col>

                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <v-col cols="12" >
                                <label style="font-weight: 600;">{{$t('documents.document_ifu_label')}}</label><br>

                                <v-text-field
                                        :value="document._numIFU"
                                        :label="$t('documents.document_ifu_label')"
                                        solo
                                        disabled
                                ></v-text-field>
                            </v-col>


                        </div>
                        <div class="col-6">
                            <v-col cols="12" >
                                <label style="font-weight: 600;">{{$t('documents.document_ifu_text')}}</label><br>

                                <div v-if="document._fileIFU">
                                    <a :href="base+document._fileIFU" target="_blank">

                                        <v-text-field
                                                value="Document IFU"
                                                :label="$t('documents.document_ifu_file')"
                                                solo
                                                disabled
                                        ></v-text-field>
                                    </a>

                                </div>
                                <div v-else>
                                    <v-text-field
                                            value="Null"
                                            :label="$t('documents.document_ifu_file')"
                                            solo
                                            disabled
                                    ></v-text-field>
                                </div>

                            </v-col>

                        </div>
                    </div>
                </div>
            </div>


        </div>
    </div>

</template>

<script>
    import {mapState} from "vuex";
    import * as Swal from "sweetalert2";
    export default {
        name: "MarchandDocument",
        data () {
            return {
                tabs: null,
                submitting:false,
                valid:true,
                lazy:false,
                mis:false,
                errors:undefined,
                search: '',
                base:process.env.FILE_BASE_URL_DOC,
                dialog: '',
                id:undefined,
                menu: false,
                menus: false,
                headers: [

                ],
                editedIndex: -1,
                editedItem: {
                    _numCard: '',
                    _fileCard: '',
                    _numRCCM: '',
                    _fileRCCM: '',
                    _fileCar: '',
                    _fileRCC: '',
                    _fileIF: '',
                    _numIFU: '',
                    _fileIFU: '',
                    _code: '',
                    _valide: '',
                    _created_at: 0,
                    _id:''
                },
                defaultItem: {
                    _numCard: '',
                    _fileCard: '',
                    _numRCCM: '',
                    _fileRCCM: '',
                    _numIFU: '',
                    _fileIFU: '',
                    _fileCar: '',
                    _fileRCC: '',
                    _fileIF: '',
                    _code: '',
                    _valide: '',
                    _created_at: 0,
                    _id:''
                },
                numRules: [
                    v => !!v || this.$t('documents.num_passport_required'),
                    // v => (v && v.length <= 10) || 'Name must be less than 10 characters',
                ],
                numrRules: [
                    v => !!v || this.$t('documents.num_rccm_required'),
                    // v => (v && v.length <= 10) || 'Name must be less than 10 characters',
                ],
                numiRules: [
                    v => !!v || this.$t('documents.num_ifu_required'),
                    // v => (v && v.length <= 10) || 'Name must be less than 10 characters',
                ],
                fileRules: [
                    v => !!v || this.$t('documents.file_passport_required'),
                    v => !v || v.size < 2000000 || 'Taille maximimun 2 MB!',

                ],

                fileiRules: [
                    v => !!v || this.$t('documents.file_ifu_required'),
                    v => v.type==='application/pdf' || this.$t('invalid_file'),
                    v => !v || v.size < 2000000 || 'Taille maximimun 2 MB!',



                ],
                filerRules: [
                    v => !!v || this.$t('documents.file_rccm_required'),
                    v => v.type==='application/pdf' || this.$t('invalid_file'),
                    v => !v || v.size < 2000000 || 'Taille maximimun 2 MB!',

                ],

            }
        },
        computed: {
            user : function(){
                return this.$store.getters.auth
            },
            formTitle () {
                return this.editedIndex === -1 ? this.$t('Nouveau document') : this.$t('Modifier document')
            },
            ...mapState('documents/',['document']),
            ...mapState('marchands/',['marchand']),



        },
        mounted(){

            this.initialize();
        },
        watch: {
            dialog (val) {
                val || this.close()
            },
        },
        methods: {

            initialize () {
                this.$store.dispatch('marchands/getMarchandOne').then(response => {
                    console.log('Marchand',response)
                });
                let marchand=this.marchand;
                this.$store.dispatch('documents/getDocumentOne',marchand._id).then(response => {
                    console.log('Mon document',response)

                });

                if (this.document){
                    this.editedItem=this.document;
                }
            },
            editItem (item) {
                this.editedIndex = this.document.indexOf(item)
                this.editedItem = Object.assign({}, item)
                this.dialog = true
                this.id = item._id;
            },

            deleteItem (item) {
                Swal.fire({
                    icon: 'warning',
                    timerProgressBar: false,
                    text: this.$t('delete_warning'),
                    confirmButtonText: this.$t('delete'),
                    cancelButtonText: this.$t('cancel'),
                    showCancelButton: true,
                    confirmButtonColor:'#29B3A6'

                }).then(result => {
                    if (result.value) {
                        this.submitting = true;
                        this.$store.dispatch('documents/deleteDocument', item._id).then((result) => {
                            this.submitting = false;
                            Swal.fire({
                                icon: 'success',
                                timer: 3000,
                                timerProgressBar: false,
                                text: this.$t(result.message),
                                position: 'top-end',
                                showConfirmButton: false
                            })
                        })
                    }
                    this.$store.dispatch('documents/getDocumentOne').then(response=>{
                        window.console.log('marchands',response)

                    });
                })
            },

            close () {
                this.dialog = false;
                this.$nextTick(() => {
                    this.document = Object.assign({}, this.defaultItem)
                    this.editedIndex = -1
                });
                this.$refs.form.reset()
            },

            save () {
                let responseObj = {};
                let VueBox = this;
                let data = new FormData();
                this.mis=true;
                data.append("user_id",this.$store.getters.auth._id);
                if(this.editedItem._numCard)
                data.append("numCard",this.editedItem._numCard);
                if(this.editedItem._numRCCM)
                data.append("numRCCM",this.editedItem._numRCCM);
                if(this.editedItem._numIFU)
                data.append("numIFU",this.editedItem._numIFU);
                console.log('Carte',this.editedItem._fileRCC)
                if (this.editedItem._fileCar===undefined) {
                    data.append("fileCard", this.document._fileCard);
                }
                else{
                    data.append("fileCard", this.editedItem._fileCar);

                }
                if (this.editedItem._fileRCC) {
                    data.append("fileRCCM",this.editedItem._fileRCC);
                }
                if (this.editedItem._fileIFU) {
                    data.append("fileIFU",this.editedItem._fileIFU);
                }
                if (this.document)
                    data.append("id",this.editedItem._id);
                this.submitting = true;

                this.$store.dispatch('documents/setDocument',data).then((response)=>{
                    responseObj.update_error = response.error;
                    responseObj.message = response.message;
                    this.errors = responseObj;
                    this.submitting=false;
                    if (!response.error){
                        VueBox.toast('success',this.$t(response.message));
                    }
                });
/*
                window.location = window.origin+'/settings'
*/

            },
            validate () {
                this.$refs.form.validate()
            },
            reset () {
                this.$refs.form.reset()
            },
            checkisDashboard(){
                this.$emit('checkisDashboard',true);
            },

        },
        created() {
            this.checkisDashboard();
            this.initialize()
        },
    }
</script>

<style scoped>

</style>